import "./financial-plan-status.scss";

interface FinancialPlanStatusInterface {
  content: string,
  status: "success" | "pending",
}

const FinancialPlanStatus = ({...props}:FinancialPlanStatusInterface) => {
  return (
    <div className={'polymer-financial-plan-status polymer-financial-plan-status__'+ props.status}>
      <p>{props.content}</p>
    </div>
  )
}

export default FinancialPlanStatus